import SingleSelectPage from "@components/SingleSelectPage"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

const OPTIONS = ["female", "male"] as const

export default function Gender() {
  const { t } = useTranslation()

  return (
    <SingleSelectPage
      translationKey="gender"
      options={OPTIONS}
      subtitleKey="info"
      headerContent={
        <div className="flex shrink-0 items-center justify-end">
          <Link
            className="hover:text-custom-charcoal text-sm font-semibold text-gray-400"
            to="/account/sign-in"
          >
            {t("shared.signIn")}
          </Link>
        </div>
      }
    />
  )
}
